import {
  Box,
  chakra,
  Flex,
  Grid,
  Icon,
  shouldForwardProp,
  Text,
  useClipboard,
  useColorModeValue,
  useToast
} from '@chakra-ui/react';
import { isValidMotionProp, motion } from 'framer-motion';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IoCloseOutline } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';

import { commonOpacity, gameListFromBottom } from '../../animateConstant';
import { actionLogout } from '../../api/postApi';
import UserLogout from '../../api/UserLogout';
import { useMenuConfig } from '../../components/SignInUp/menuConfig';
import useCheckLogin from '../../hook/useCheckLogin';
import { notice } from '../../redux/action/action';
import { clearFavoriteGameList } from '../../redux/action/game/gameAction';
import {
  cleanMemberInfo,
  clearTransferWallet
} from '../../redux/action/member/memberAction';
import GoogleLogout from '../Singin/components/googleLogout';
import CachePop from './components/CachePop';
import ClearCashPop from './components/clearCashPop';
import CommonSelectTab from './components/CommonSelectTab';
import ProfileCard from './components/ProfileCard';
import ProfileCardNotLogin from './components/profileCardNotLogin';
import useLogoutButton from './components/useLogoutButton';

const motionProps = {
  initial: commonOpacity.initial,
  animate: commonOpacity.animate,
  exit: commonOpacity.exit,
  transition: commonOpacity.transition
};

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop)
});

const Aside = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const { isLogin } = useCheckLogin();

  const { setValue } = useClipboard('');

  const memberData = useSelector((state) => state.isMemberInfo);
  const cachePop = useSelector((state) => state.isCachePop);
  const clearCashPop = useSelector((state) => state.isClearCashPop);

  const { asideLogoutBtn } = useLogoutButton();

  const menuColor = useColorModeValue('light.100', 'light.100');

  const menu = useMenuConfig();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setValue(memberData?.uid);
  }, [memberData]);

  return (
    <ChakraBox
      display="flex"
      flexDirection={`column`}
      gap={{
        base: '3px',
        md: '5px'
      }}
      overflowY="scroll"
      h="100%"
      {...motionProps}
      className="no-scrollbar"
    >
      <Flex
        alignItems={`center`}
        justifyContent={{
          base: 'space-between',
          md: 'flex-start'
        }}
      >
        <Flex direction={`column`} ml="10px"></Flex>
        <Box
          display={{
            base: 'block',
            md: 'none'
          }}
          position={'absolute'}
          top="5px"
          right="5px"
          color="special.100"
          fontSize={`4xl`}
        >
          <Link to="../">
            <IoCloseOutline className="cursor-pointer" />
          </Link>
        </Box>
      </Flex>
      <Box>{isLogin ? <ProfileCard /> : <ProfileCardNotLogin />}</Box>
      {isLogin && (
        <Box mb="10px" px="5px">
          <CommonSelectTab />
        </Box>
      )}
      <Flex as="section" direction={`column`} px="5px" gap="15px">
        {Object?.keys(menu).map((route) => {
          const list = menu[route];
          return (
            <ChakraBox
              {...gameListFromBottom}
              gap="5px"
              as="section"
              borderRadius={`20px`}
              bg={'#083549'}
              overflow="hidden"
            >
              <Text
                py="10px"
                px="20px"
                color="white"
                fontSize="md"
                fontWeight={`600`}
                bg="#288FA1"
                borderBottom="1px solid"
                borderColor="brand.100"
                position="relative"
                borderTopLeftRadius={`20px`}
                borderTopRightRadius={`20px`}
              >
                {i18n(route)}
              </Text>
              <Grid
                pt="15px"
                pb="30px"
                gridTemplateColumns={`repeat(4, minmax(0, 1fr))`}
                gap="10px"
                overflow="hidden"
                px="20px"
              >
                {list
                  ?.filter((route) => {
                    return !route?.hidden;
                  })
                  ?.filter((item) => {
                    if (item.auth) {
                      if (item.verify) {
                        return false;
                      }
                      return isLogin === item.auth;
                    } else {
                      return true;
                    }
                  })
                  ?.map((item) => {
                    return (
                      <>
                        <Box
                          role="group"
                          onClick={() => {
                            if (item.func) {
                              item.func();
                              return;
                            }
                            if (item.hashed || item.link === 'service-group') {
                              // 特殊處理 service-group
                              navigate(`/${item.link}`);
                            } else {
                              navigate(`../profile/${item.link}`);
                            }
                          }}
                          color={menuColor}
                          display="flex"
                          gap="5px"
                          flexDirection={`column`}
                          alignItems={`center`}
                          cursor={`pointer`}
                          className={`${item.className}`}
                        >
                          <Box
                            w="35px"
                            h="35px"
                            display="flex"
                            alignItems={`center`}
                            justifyContent={`center`}
                            borderRadius={`full`}
                          >
                            <Icon
                              as={item.icon}
                              fontSize="3xl"
                              color={'#CCFFFF'}
                            />
                          </Box>
                          <Text
                            fontSize="xs"
                            letterSpacing={`tight`}
                            w="100%"
                            textAlign={`center`}
                            fontWeight={
                              location.pathname.includes(item.link)
                                ? '700'
                                : '400'
                            }
                            color={'#CCFFFF'}
                          >
                            {item.text}
                          </Text>
                          {/* <HiChevronRight className="md:hidden" /> */}
                        </Box>
                        {item.children && item.children}
                      </>
                    );
                  })}
              </Grid>
            </ChakraBox>
          );
        })}
      </Flex>
      {asideLogoutBtn}
      {cachePop && <CachePop />}
      {clearCashPop && <ClearCashPop />}
    </ChakraBox>
  );
};

export default Aside;
